import { RouteItem } from '@elsa-zku/lib/components/App/components/Content';

const routes: RouteItem[] = [
  {
    path:      '/orders',
    name:      'orders',
    component: () => import('src/routes/Orders'),
  },
  {
    path:      '/orders/create',
    name:      'orderCreate',
    component: () => import('src/routes/OrderCreate'),
  },
  {
    path:      '/orders/:orderId',
    name:      'order',
    component: () => import('src/routes/Order'),
  },
  {
    path:      '/passes',
    name:      'passes',
    component: () => import('src/routes/Passes'),
  },
  {
    path:      '/categories',
    name:      'categories',
    component: () => import('src/routes/Categories'),
  },
  {
    path:      '/categories/create',
    name:      'categoryCreate',
    component: () => import('src/routes/CategoryForm'),
  },
  {
    path:      '/categories/:id',
    name:      'category',
    component: () => import('src/routes/Category'),
  },
  {
    path:      '/categories/:id/edit',
    name:      'categoryEdit',
    component: () => import('src/routes/CategoryForm'),
  },
  {
    path:      '/categories/:categoryId/create-service',
    name:      'serviceCreate',
    component: () => import('src/routes/ServiceForm'),
  },
  {
    path:      '/categories/services/archive',
    name:      'serviceArchive',
    component: () => import('src/routes/ServicesArchive'),
  },
  {
    path:      '/categories/services/:id',
    name:      'serviceEdit',
    component: () => import('src/routes/ServiceForm'),
  },
  {
    path:      '/building-services',
    name:      'buildingsServices',
    component: () => import('src/routes/BuildingsServices'),
  },
  {
    path:      '/building-services/:id',
    name:      'buildingServices',
    component: () => import('src/routes/BuildingServices'),
  },
  {
    path:      '*',
    name:      'notFound',
    component: () => import('@elsa-zku/lib/components/NotFoundRoute'),
  },
];

export default routes;
